'use client';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import type { HeaderProps } from './header.props';
import { cn } from '@bells/core/lib/utils';

export const ThemeSwitcher = ({}: HeaderProps) => {
  const { setTheme, theme } = useTheme();
  return (
    <button
      className={cn(
        'inline-flex h-10 w-10 items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&>svg]:pointer-events-none [&>svg]:size-5 [&>svg]:shrink-0'
      )}
      onClick={() => {
        setTheme(theme === 'dark' ? 'light' : 'dark');
      }}
    >
      <Sun className='h-[70%] w-[70%] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0' />
      <Moon className='absolute h-[70%] w-[70%] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100' />
      <span className='sr-only'>Toggle theme</span>
    </button>
  );
};
